var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: _vm.$t("m.add_remark"),
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        },
        close: function($event) {
          return _vm.onDialogClose("theForm")
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "theForm",
          attrs: {
            size: "small",
            model: _vm.model,
            rules: _vm.rules,
            "label-position": "left",
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("m.remark"), prop: "remark" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("m.add_remark"), maxlength: "10" },
                model: {
                  value: _vm.model.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "remark", $$v)
                  },
                  expression: "model.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("m.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.loading.btn
              },
              on: { click: _vm.doRemarkAdd }
            },
            [_vm._v(_vm._s(_vm.$t("m.Confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16d1be62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d1be62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/approval/dialogs/UserRemarkDialog.vue
// module id = null
// module chunks = 